import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/shared/store/store';
import {
  loginRequest,
  registerRequest,
  logoutRequest,
  refreshTokenRequest,
  verifyTokenRequest,
  autoCompleteOnboardingRequest,
  clearError,
} from '@/features/security/sagas/auth-slice';
import { LoginCredentials, RegisterData } from '@/shared/types';
import { useSession } from './useSession';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const session = useSession();

  const login = async (credentials: LoginCredentials) => {
    dispatch(clearError());
    dispatch(loginRequest({ credentials }));
  };

  const register = async (userData: RegisterData) => {
    dispatch(clearError());
    dispatch(registerRequest({ userData }));
  };

  const logout = () => {
    dispatch(logoutRequest());
  };

  const refreshTokenAction = (refreshToken: string) => {
    dispatch(refreshTokenRequest({ refreshToken }));
  };

  const verifyToken = () => {
    dispatch(verifyTokenRequest());
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  const autoCompleteOnboarding = () => {
    dispatch(autoCompleteOnboardingRequest({}));
  };

  return {
    login,
    register,
    logout,
    refreshTokenAction,
    verifyToken,
    clearAuthError,
    autoCompleteOnboarding,
    ...session,
  };
};
